import React from 'react'
import {Divider, Header, Image} from 'semantic-ui-react';
import {CustomContainer} from '../../custom-common';
import STRATEGIC_PARTNER from "../../../constants/strategicPartners";

export const NoContent = ({
    title = 'You have no messages',
    details = `Have a question? Send us a note and a ${STRATEGIC_PARTNER.LABEL} Concierge will get back to you shortly.`
}) => (
    <CustomContainer textAlign="center" padded={"very"}>
        <Divider hidden/>
        <Image
            centered
            style={{width: "110px"}}
            src={"https://brella-platform-assets.s3.amazonaws.com/common/Illustrations/Claims-Flow/EmptyState_greyscale.png"}
        />
        <Header as="h4" className="neutral700Text">{title}</Header>
        <p className={"neutral700Text"}>{details}</p>
        <Divider hidden/>
    </CustomContainer>
)

NoContent.displayName = 'NoContent'